import http from '@/utils/http/http'

// 获取用户信息
export function getUserInfo () {
  return http.get('/security/getUserInfo', {}, {auth: true})
}